document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.section-resource-list').forEach(function (section) {
    var button = section.querySelector('.section-resource-list__header a');
    var grid = section.querySelector('.resource-list');
    if (button && grid) {
      button.style.display = 'block';
      button.style.width = 'fit-content';
      button.style.margin = '1.5rem auto 0';
      grid.insertAdjacentElement('afterend', button);
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('form[action="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) {
        return response.json();
      })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function(error) {
        console.error('Error:', error);
      });
    });
  }
});
